import React from 'react';
import { useTranslation } from 'react-i18next';
import ColorDot from '../ColorDot';

const TableLegend = () => {
  const { t } = useTranslation();
  return (
    <div className="gap-1 d-flex align-items-center">
      <i>{t('components.table.legend.knownCandidate')}</i>
      <ColorDot />
    </div>
  );
};

export default TableLegend;
